<p class="hint">
  The dev API answers with the picked scenario instead of the real endpoint, for you only, until you clear it. One
  scenario per group; groups combine.
</p>
@for (group of groups; track group.name) {
  <fieldset>
    <legend
      ><noxo-card-overline>{{ group.name }}</noxo-card-overline></legend
    >
    <label
      class="option"
      [class.selected]="!selection()[group.name]">
      <noxo-radio>
        <input
          type="radio"
          [name]="group.name"
          [checked]="!selection()[group.name]"
          (change)="pick(group.name)" />
      </noxo-radio>
      <span class="text"><strong>Real API</strong></span>
    </label>
    @for (scenario of group.scenarios; track scenario.name) {
      <label
        class="option"
        [class.selected]="selection()[group.name] === scenario.name">
        <noxo-radio>
          <input
            type="radio"
            [name]="group.name"
            [checked]="selection()[group.name] === scenario.name"
            (change)="pick(group.name, scenario.name)" />
        </noxo-radio>
        <span class="text">
          <strong>{{ scenario.title }}</strong>
          <span>{{ scenario.description }}</span>
        </span>
        @if (scenario.screen; as screen) {
          <a
            class="open"
            [href]="basePath + screen"
            >Open</a
          >
        }
      </label>
    }
  </fieldset>
}
<footer>
  <button
    type="button"
    noxo-button="primary"
    size="s"
    [disabled]="!changed()"
    (click)="apply()">
    Apply and reload
  </button>
  <button
    type="button"
    noxo-button="tertiary"
    size="s"
    [disabled]="!hasActive"
    (click)="clear()">
    Clear all
  </button>
</footer>
